import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "icon"];

  connect() {}

  toggle(event) {
    if (event) event.preventDefault();
    this.menuTarget.classList.toggle("hidden");

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180");
    }
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");

      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("rotate-180");
      }
    }
  }
}
